export default __webpack_public_path__ + "static/media/blog.9b2059c3.png";